import { useUnit } from 'effector-react';
import { createAddCurrencyModal } from 'features/add-currency';
import { createAddWalletModal } from 'features/add-wallet';
import { createBlockWalletModal } from 'features/block-wallet';
import { createDeleteWalletModal } from 'features/delete-wallet';
import { createDepositWalletModal } from 'features/deposit-wallet';
import { createUnblockWalletModal } from 'features/unblock-wallet';
import { createWithdrawWalletModal } from 'features/withdraw-wallet';
import { viewerModel } from 'entities/viewer';
import { createWalletRegistry } from 'entities/wallet';
import { USER_ROLES } from 'shared/api';
import { accountPageModel, accountPageWalletsModel } from '../../model';
import cls from './account-page-wallets.module.scss';

const WalletRegistry = createWalletRegistry(accountPageWalletsModel.walletRegistryModel);

export const AddWalletModal = createAddWalletModal(accountPageWalletsModel.addWalletModel);

export const AddCurrencyModal = createAddCurrencyModal(accountPageWalletsModel.addCurrencyModel);

export const WithdrawWalletModal = createWithdrawWalletModal(
	accountPageWalletsModel.withdrawWalletModel,
);

export const DepositWalletModal = createDepositWalletModal(
	accountPageWalletsModel.depositWalletModel,
);

export const BlockWalletModal = createBlockWalletModal(accountPageWalletsModel.blockWalletModel);

export const UnblockWalletModal = createUnblockWalletModal(
	accountPageWalletsModel.unblockWalletModel,
);

export const DeleteWalletModal = createDeleteWalletModal(accountPageWalletsModel.deleteWalletModel);

export const AccountPageWallets = () => {
	const [accountId, role, isCurrentAccount] = useUnit([
		accountPageModel.$accountId,
		viewerModel.$role,
		accountPageModel.$isCurrentAccount,
	]);

	const isVisibleAddCurrency = role === USER_ROLES.god && isCurrentAccount;

	return (
		<>
			<WalletRegistry
				emptyActionSlot={
					isVisibleAddCurrency ? <AddCurrencyModal.Button /> : <AddWalletModal.Button />
				}
				topBarActionSlot={
					isVisibleAddCurrency ? <AddCurrencyModal.Button /> : <AddWalletModal.Button />
				}
				tableTdActionSlot={(wallet) =>
					accountId !== null && (
						<div className={cls.accountPageWalletsActions}>
							<div className={cls.accountPageWalletsActionsGroup}>
								<DepositWalletModal.Button modalData={{ ...wallet, accountId }} />
								<WithdrawWalletModal.Button modalData={{ ...wallet, accountId }} />
							</div>
							<div className={cls.accountPageWalletsActionsGroup}>
								{wallet.isLocked ? (
									<UnblockWalletModal.ActionIcon modalData={{ ...wallet, accountId }} />
								) : (
									<BlockWalletModal.ActionIcon modalData={{ ...wallet, accountId }} />
								)}
								<DeleteWalletModal.ActionIcon modalData={{ ...wallet, accountId }} />
							</div>
						</div>
					)
				}
				className={cls.accountPageWalletsWalletRegistry}
			/>
			{!isVisibleAddCurrency && <AddWalletModal />}
			<WithdrawWalletModal />
			<DepositWalletModal />
			<BlockWalletModal />
			<UnblockWalletModal />
			<DeleteWalletModal />
			{isVisibleAddCurrency && <AddCurrencyModal />}
		</>
	);
};
